import { useNavigate } from '@remix-run/react';
import { ChevronRight } from '~/icons';
import { SocioIco } from '~/icons';
import { formatStringToBRL } from '~/lib/currency';
import { CashbackBallance } from '~/type/Cashback';


interface BannerCashbackProps {
  cashbackBallance?: CashbackBallance
}

export function BannerCashback({ cashbackBallance }: BannerCashbackProps) {
  const navigate = useNavigate();
  const available = parseFloat((cashbackBallance?.available || '0').replace(',', '.'));

  return (
    <div
      className="p-4 rounded cursor-pointer bg-primary-socio  focus:outline-none focus:ring-2 focus:ring-primary-info focus:ring-offset-1"
      onClick={() => navigate('/myaccount/extrato')}
      role="button"
      aria-label="Ir para a página de extrato de cashback"
      tabIndex={0}
      title='Ir para a página de extrato de cashback'
    >
      <div className="flex justify-between">
        <p className="text-white text-sm" aria-hidden="true">
          {available > 0 ? (
            "Cashback disponível"
          ) : (
            "Saldo a receber"
          )}
        </p>
        <SocioIco aria-hidden="true" />
      </div>
      <div className="flex items-end justify-between">
        <h1 className="font-oswald line text-white font-bold text-2xl" aria-hidden="true">
          {available > 0 ? (
            formatStringToBRL(cashbackBallance?.available || '')
          ) : (formatStringToBRL(cashbackBallance?.pending || ''))}
        </h1>
        <div className='flex gap-1 items-center'>
          <span className='font-medium text-sm text-white'>Consultar extrato</span> <ChevronRight className="fill-white text-lg mt-[1px]" aria-hidden="true" />
        </div>
      </div>
    </div>
  );
}
